/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountRewardStatsItem
 */
export interface AccountRewardStatsItem {
    /**
     * 
     * @type {number}
     * @memberof AccountRewardStatsItem
     */
    dateTime: number;
    /**
     * 
     * @type {string}
     * @memberof AccountRewardStatsItem
     */
    reward: string;
}

export function AccountRewardStatsItemFromJSON(json: any): AccountRewardStatsItem {
    return AccountRewardStatsItemFromJSONTyped(json, false);
}

export function AccountRewardStatsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountRewardStatsItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateTime': json['dateTime'],
        'reward': json['reward'],
    };
}

export function AccountRewardStatsItemToJSON(value?: AccountRewardStatsItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dateTime': value.dateTime,
        'reward': value.reward,
    };
}


